module.exports = __webpack_public_path__ + "static/img/AIIcon.4d5c17e9.png";